// Consentement aux cookies (RGPD / recommandations CNIL).
// - Rien n'est chargé (Google Analytics, Meta Pixel) tant que le visiteur n'a pas accepté.
// - Le choix est conservé 6 mois, puis redemandé.
// - Si le visiteur retire son accord, les cookies posés sont supprimés et la page est rechargée.
import { GA_MEASUREMENT_ID, META_PIXEL_ID } from "./siteConfig";

const KEY = "sideb_cookie_consent";
const VERSION = 1;
const MAX_AGE_MS = 182 * 24 * 3600 * 1000; // ~6 mois
const OPEN_EVENT = "sideb:open-cookie-settings";

export function readConsent() {
  try {
    const raw = window.localStorage.getItem(KEY);
    if (!raw) return null;
    const c = JSON.parse(raw);
    if (c.version !== VERSION || !c.date || Date.now() - c.date > MAX_AGE_MS) return null;
    return { analytics: !!c.analytics, ads: !!c.ads, date: c.date };
  } catch {
    return null;
  }
}

export function saveConsent({ analytics, ads }) {
  const previous = readConsent();
  try {
    window.localStorage.setItem(KEY, JSON.stringify({ version: VERSION, analytics: !!analytics, ads: !!ads, date: Date.now() }));
  } catch {
    /* stockage indisponible : le bandeau réapparaîtra à la prochaine visite */
  }
  // Retrait d'un accord déjà donné : on supprime les cookies et on recharge pour arrêter les traceurs
  const withdrew = previous && ((previous.analytics && !analytics) || (previous.ads && !ads));
  if (withdrew) {
    clearTrackingCookies();
    window.location.reload();
    return;
  }
  applyConsent({ analytics, ads });
}

// Charge les outils autorisés (une seule fois chacun)
export function applyConsent(consent) {
  if (!consent) return;
  if (consent.analytics && GA_MEASUREMENT_ID) loadGoogleAnalytics(GA_MEASUREMENT_ID);
  if (consent.ads && META_PIXEL_ID) loadMetaPixel(META_PIXEL_ID);
}

export function openCookieSettings() {
  window.dispatchEvent(new Event(OPEN_EVENT));
}
export function onOpenCookieSettings(handler) {
  window.addEventListener(OPEN_EVENT, handler);
  return () => window.removeEventListener(OPEN_EVENT, handler);
}

function loadGoogleAnalytics(id) {
  if (window.__sidebGaLoaded) return;
  window.__sidebGaLoaded = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(id)}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments); // eslint-disable-line prefer-rest-params
  };
  window.gtag("js", new Date());
  window.gtag("config", id, { anonymize_ip: true });
}

function loadMetaPixel(id) {
  if (window.fbq) return;
  /* eslint-disable */
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = "2.0";
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
  /* eslint-enable */
  window.fbq("init", id);
  window.fbq("track", "PageView");
}

function clearTrackingCookies() {
  const host = window.location.hostname;
  const domains = ["", host, `.${host}`, `.${host.split(".").slice(-2).join(".")}`];
  document.cookie.split(";").forEach((c) => {
    const name = c.split("=")[0].trim();
    if (/^(_ga|_gid|_gat|_fbp|_fbc)/.test(name)) {
      domains.forEach((d) => {
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/${d ? `; domain=${d}` : ""}`;
      });
    }
  });
}
